"use client";

import React from "react";
import { motion } from "framer-motion";
import "./ProcessSection.scss";
import Image from "next/image";

const ProcessSection = ({ data }) => {
  const { title, description, items } = data;

  return (
    <section className="process-section">
      <div className="container">
        <div className="process-top">
          <h2>{title}</h2>

          <p>{description}</p>
        </div>

        <div className="process-grid">
          {items?.map((item, index) => (
            <div className="process-card" 
            key={item.title || index}>
              <div className="icon-box">
                <Image
                  src={item.icon}
                  alt={item.title}
                  width={28}
                  height={28}
                />
              </div>

              <h4>{item.title}</h4>

              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
